import { motion } from "framer-motion";

const STEPS = [
  {
    num: "01",
    title: "Discover",
    desc: "We dive into your operations, interview your team and surface the workflows drowning in manual effort.",
  },
  {
    num: "02",
    title: "Design",
    desc: "A blueprint of agents, pipelines and integrations — scoped to ROI, with clear success metrics before a line of code.",
  },
  {
    num: "03",
    title: "Deploy",
    desc: "Rapid build cycles with weekly demos. Your automation goes live in weeks, not quarters.",
  },
  {
    num: "04",
    title: "Scale",
    desc: "We monitor, retrain and expand. Each deployment becomes the current that carries the next.",
  },
];

export const Process = () => {
  return (
    <section id="process" className="relative py-28 lg:py-36 px-6" data-testid="process-section">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="mb-20 text-center"
        >
          <p className="text-xs tracking-[0.3em] uppercase text-[#00F2FE] mb-5">Chapter 02 — How it works</p>
          <h2 className="font-['Outfit'] font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#E8F1F5]">
            From deep dive to <span className="gradient-text font-medium">open water</span>
          </h2>
        </motion.div>

        <div className="relative">
          <div className="absolute left-[27px] md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-[#00F2FE]/60 via-[#10E59A]/50 to-transparent md:-translate-x-1/2" />
          <div className="flex flex-col gap-16">
            {STEPS.map((step, i) => (
              <motion.div
                key={step.num}
                data-testid={`process-step-${i}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: 0.1 }}
                className={`relative flex items-start gap-8 md:gap-0 ${i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"}`}
              >
                <div className="absolute left-[27px] md:left-1/2 top-2 w-3.5 h-3.5 -translate-x-1/2 rounded-full bg-[#00F2FE] shadow-[0_0_20px_4px_rgba(0,242,254,0.5)] animate-pulse-glow" />
                <div className={`pl-16 md:pl-0 md:w-1/2 ${i % 2 === 0 ? "md:pr-16 md:text-right" : "md:pl-16"}`}>
                  <span className="font-['Outfit'] text-5xl font-light text-[#00F2FE]/25">{step.num}</span>
                  <h3 className="font-['Outfit'] font-medium text-2xl text-[#E8F1F5] mt-2 mb-3">{step.title}</h3>
                  <p className="text-sm md:text-base leading-relaxed text-[#8AA1B1]">{step.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
